import { useTranslation } from 'react-i18next';
import { Avatar } from 'components/Avatar';
import { DocumentTitle } from 'components/DocumentTitle';
import { Heading, Paragraph } from 'components/Typography';
import { clientInitials, FullClient, ProfileSelectForm } from 'domains/client';
import { FormData } from 'domains/client/ProfileSelectForm/schema';
import { ContentContainer } from 'components/ContentContainer';
import { SubmitHandler } from 'react-hook-form';

export type Props = {
  activeClientId: string | null;
  clients: FullClient[];
  onSubmit: SubmitHandler<FormData>;
  onSignOut: () => void;
};

export const ProfileSelectUi = ({ clients, activeClientId, onSubmit }: Props): JSX.Element => {
  const { t } = useTranslation();

  const clientOptions = clients.map(client => ({
    label: `${client.clientPreferredName ?? client.clientFirstName} ${client.clientLastName}`,
    value: client.clientID,
    startAdornment: <Avatar>{clientInitials(client)}</Avatar>,
  }));

  return (
    <>
      <DocumentTitle>{t('profileSelect.pageTitle')}</DocumentTitle>

      <ContentContainer variant="full" className="items-center">
        <div className="text-center">
          <Heading className="mb-4 md:mb-12">{t('profileSelect.pageHeading')}</Heading>

          <Paragraph className="mb-32 md:mb-48" gutterBottom={false}>
            {t('profileSelect.introText')}
          </Paragraph>
        </div>

        <div className="mb-24 md:mb-32 max-w-sm">
          <ProfileSelectForm
            initialData={{ clientID: activeClientId || undefined }}
            clientOptions={clientOptions}
            onSubmit={onSubmit}
          />
        </div>

        {/* TODO: Uncomment this line in V2 */}
        {/* <Paragraph className="text-center"> */}
        {/* {t('profileSelect.signOutLabelText')}{' '} */}
        {/* @NOTE(shawk): this is a special case where we have a text-link
              that logs the user out hence the onClick/preventDefault. */}
        {/* <Link
            to="#"
            className="sm-d:block"
            onClick={e => {
              e.preventDefault();
              onSignOut();
            }}
          >
            {t('profileSelect.signOutLinkText')}
          </Link> */}
        {/* </Paragraph> */}
      </ContentContainer>
    </>
  );
};
